export enum TRAVEL_STATUS {
  CREATED = 1,
  PENDING_TEAM_MNG_APPROVAL = 2,
  TEAM_MNG_APPROVED = 3,
  TEAM_MNG_REJECTED = 4,
  CHANGE_REQUESTED_BY_TEAM_MNG = 5,
  BTAT_INSTRUCTIONS = 6,
  BTAT_WAITING_UPLOAD = 7,
  BTAT_PENDING_APPROVAL = 8,
  BTAT_CHANGE_REQUESTED = 9,
  BTAT_APPROVED = 10,
  PENDING_DEPARTMENT_MNG_APPROVAL = 12,
  DEPARTMENT_MNG_APPROVED = 13,
  DEPARTMENT_MNG_REJECTED = 14,
  CHANGE_REQUESTED_BY_DEPARTMENT_MNG = 15,
  READY_TO_TRAVEL = 16,
  COMPLETED = 17,
  ACCOUNTED = 19,
  EH_ACCOUNTING = 20,
}
